export default __webpack_public_path__ + "static/media/register-referral-light.fc92d9ea.png";